import * as Yup from 'yup';

export const schema = Yup.object({
	calle: Yup.string().required(),
	no_exterior: Yup.string().required(),
	no_interior: Yup.string().nullable(true),
	colonia: Yup.string().required(),
	referencia: Yup.string().required(),
	municipio: Yup.string().required(),
	localidad: Yup.string().required(),
	estado: Yup.string().required(),
	pais: Yup.string().required(),
	codigo_postal: Yup.string().required(),
});
